import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/download.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isHome = location.pathname === "/";

  const toggleMobileMenu = () => setMobileMenu(!mobileMenu);

  return (
    <nav className={`navbar ${!isHome || scrolled ? "navbar-dark" : "navbar-transparent"}`}>
      {/* Logo left */}
      <div className="navbar-logo">
        <img src={logo} alt="Logo" />
      </div>

      {/* Hamburger right */}
      <div
        className={`hamburger ${mobileMenu ? "active" : ""}`}
        onClick={toggleMobileMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Mobile Links */}
      <ul className={`navbar-links ${mobileMenu ? "mobile-active" : ""}`}>
        <li><NavLink to="/" end onClick={() => setMobileMenu(false)}>Home</NavLink></li>
        <li><NavLink to="/services" onClick={() => setMobileMenu(false)}>Services</NavLink></li>
        <li><NavLink to="/about-us" onClick={() => setMobileMenu(false)}>About</NavLink></li>
        <li><NavLink to="/contact" onClick={() => setMobileMenu(false)}>Contact</NavLink></li>
        <li className="quote-btn">
          <NavLink to="/contact" onClick={() => setMobileMenu(false)}>Get A Quote</NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
